import { t as getDictionaries } from "./getDictionaries2.js";
import { queryOptions, useQuery } from "@tanstack/react-query";
//#region src/__generated__/internal/dictionaries/hooks/useGetDictionaries.ts
const getDictionariesQueryKey = () => [{ url: "/api/mdm/internal/api/internal/dictionaries" }];
function getDictionariesQueryOptions(config = {}) {
	const queryKey = getDictionariesQueryKey();
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getDictionaries({
				...config,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Форма заявки: виды обращения, работы, примыкание, финансирование,
* типы заявителя, дороги.
* Фильтры реестра: те же дороги и виды обращения плюс статусы рассмотрения,
* условия оплаты, признаки обработки и плашки контроля срока. Здесь только
* закрытые наборы значений; станция, заявитель, инициатор, ответственный и
* оператор собираются из данных — GET /api/internal/requests/filter-values.
* @summary Справочники формы заявки и фильтров реестра
* {@link /api/mdm/internal/api/internal/dictionaries}
*/
function useGetDictionaries(options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey = resolvedOptions?.queryKey ?? getDictionariesQueryKey();
	const queryResult = useQuery({
		...getDictionariesQueryOptions(config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
export { getDictionariesQueryOptions as n, useGetDictionaries as r, getDictionariesQueryKey as t };

//# sourceMappingURL=useGetDictionaries2.js.map